import {useCallback, useState} from "react";
import {TableCell, TableRow, Typography} from "@material-ui/core";
import SimpleTable from "../../../../../../../shared/components/tables/simple-table/SimpleTable";
import {useSelector} from "react-redux";
import EmptyRow from "../../../../../../ui/tables/rows/empty-row/EmptyRow";
import DeviceDetails from "./device-details/DeviceDetails";
import {TABLE_SIZE_L, TABLE_SIZE_S} from "../offerte/OfferteHelper";

const DCDeviceTable = () => {
    const data = useSelector(state => state.contrattoDigitaleReducer.deviceTableData.data)
    const loading = useSelector(state => state.contrattoDigitaleReducer.deviceTableData.loading)
    const contrattoDetailsLoading = useSelector(state => state.contrattoDigitaleReducer.contractDetails.loading)
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [rowData, setRowData] = useState({});
    const cacheLoading = useSelector((state) => state.authReducer.cacheDigitalContractLoading)

    const handleRowClick = useCallback((row) => {
        setOpenDetailsDialog(true)
        setRowData(row);
    }, [])

    const headCells = [
        {
            id: "brand",
            text: "brand",
            width: TABLE_SIZE_S
        },
        {
            id: "modello",
            text: "modello",
            width: TABLE_SIZE_L
        },
        {
            id: "qtà-contrattualizzata",
            text: "qtà contrattualizzata",
            width: TABLE_SIZE_S
        },
        {
            id: "tipo-vendita",
            text: "tipo vendita",
            width: TABLE_SIZE_S
        },
        {
            id: "costo-attivazione",
            text: "Contributo iniziale",
            width: TABLE_SIZE_S
        },
        {
            id: "canone",
            text: "Canone",
            width: TABLE_SIZE_S
        }
    ]

    const tableRows = useCallback(() => {
        return data && data.length > 0 ? data.map((cell, idx) => {
            return (
                <TableRow key={`digital-contract-table-body-${idx}`} hover onClick={() => handleRowClick(cell)}>
                    <TableCell component="th" scope="row">
                        <Typography variant="subtitle2">{cell.brand}</Typography>
                    </TableCell>
                    <TableCell align="left"><Typography
                        variant="subtitle2">{cell.modello}</Typography></TableCell>
                    <TableCell align="left"><Typography
                        variant="subtitle2">{cell.qtaContrattualizzata}</Typography></TableCell>
                    <TableCell align="left"><Typography
                        variant="subtitle2">{cell.tipoVendita}</Typography></TableCell>
                    <TableCell align="left"><Typography
                        variant="subtitle2">{cell.costoAttivazione}</Typography></TableCell>
                    <TableCell align="left"><Typography
                        variant="subtitle2">{cell.canone}</Typography></TableCell>
                </TableRow>
            )
        }) : <EmptyRow text="dato"
                       colSpan={headCells.length}/>
    }, [data, headCells.length, handleRowClick])

    return (
        <>
            <SimpleTable
                headCells={headCells}
                tableRows={tableRows()}
                loading={loading || contrattoDetailsLoading || cacheLoading}
            />

            {openDetailsDialog ?
                <DeviceDetails
                    open={openDetailsDialog}
                    data={rowData}
                    handleDialogClose={() => setOpenDetailsDialog(false)}/>
                : null}
        </>
    )
}

export default DCDeviceTable;
